import { useFormState } from "react-dom";
import "./App.css";
import { useState } from "react";

const registrixWebsites = [
  {host: "acvirtusbolzano", name: "AC Virtus Bolzano", customUrl: "https://acvirtusbolzano.registrix.it/"},
  {host: "afc-neumarkt-egna", name: "AFC Neumarkt Egna"},
  {host: "afcgais", name: "AFC Gais"},
  {host: "afcterlan", name: "AFC Terlan"},
  {host: "alpine-ski-asmerano", name: "Alpine Ski AS Merano"},
  {host: "asc-sarntal", name: "ASC Sarntal"},
  {host: "ascalgund", name: "ASC Algund"},
  {host: "asceggen", name: "ASC Eggen"},
  {host: "ascg", name: "ASCG"},
  {host: "asckaltern", name: "ASC Kaltern"},
  {host: "asclajen", name: "ASC Lajen"},
  {host: "ascplose", name: "ASC Plose"},
  {host: "asdlaivesbronzolo", name: "ASD Laives Bronzolo"},
  {host: "asv-freienfeld", name: "ASV Freienfeld"},
  {host: "asv-klausen", name: "ASV Klausen"},
  {host: "asv-oberland", name: "ASV Oberland"},
  {host: "asv-prad", name: "ASV Prad"},
  {host: "asv-truden", name: "ASV Truden"},
  {host: "asv-wiesen", name: "ASV Wiesen"},
  {host: "asvfeldthurns", name: "ASV Feldthurns"},
  {host: "asvgargazon", name: "ASV Gargazon"},
  {host: "asvjenesien", name: "ASV Jenesien"},
  {host: "asvkastelbell-tschars", name: "ASV Kastelbell-Tschars"},
  {host: "asvlatsch", name: "ASV Latsch"},
  {host: "asvmals", name: "ASV Mals"},
  {host: "asvmilland", name: "ASV Milland"},
  {host: "asvmontanraiffeisen", name: "ASV Montan Raiffeisen"},
  {host: "asvnals-raiffeisen", name: "ASV Nals Raiffeisen"},
  {host: "asvpartschins", name: "ASV Partschins"},
  {host: "asvraas", name: "ASV Raas"},
  {host: "asvsteinegg", name: "ASV Steinegg"},
  {host: "asvterenten", name: "ASV Terenten"},
  {host: "asvtraminfussball", name: "ASV Tramin Fußball"},
  {host: "asvunterlandberg", name: "ASV Unterlandberg"},
  {host: "asvvoeran", name: "ASV Vöran"},
  {host: "boznerfc", name: "Bozner FC"},
  {host: "fc-suedtirol", name: "FC Südtirol"},
  {host: "fcgitschbergjochtal", name: "FC Gitschberg Jochtal"},
  {host: "fussball-ueberetsch", name: "Fußball Überetsch"},
  {host: "fussballzentrum-pustertal", name: "Fußballzentrum Pustertal"},
  {host: "hc-falcons", name: "HC Falcons"},
  {host: "hc-neumarkt", name: "HC Neumarkt"},
  {host: "hceppan", name: "HC Eppan"},
  {host: "hcgherdeina", name: "HCG Herdeina"},
  {host: "hcj", name: "HCJ"},
  {host: "hcpustertaljunior", name: "HC Pustertal Junior"},
  {host: "hsv", name: "HSV"},
  {host: "kaltern-fussball", name: "Kaltern Fußball"},
  {host: "kaltern-yoseikan", name: "Kaltern Yoseikan"},
  {host: "ridnauntal", name: "Ridnauntal"},
  {host: "rk", name: "RK"},
  {host: "scm-ski", name: "SCM Ski"},
  {host: "sgschlern", name: "SG Schlern"},
  {host: "sinigocalcio", name: "Sinigo Calcio"},
  {host: "spg-moelten-voeran-hafling", name: "SPG Mölten Vöran Hafling"},
  {host: "spg-rst", name: "SPG RST"},
  {host: "sportclub-meran", name: "Sportclub Meran"},
  {host: "ssvbruneck", name: "SSV Bruneck"},
  {host: "ssvleifers", name: "SSV Leifers"},
  {host: "ssvnaturns", name: "SSV Naturns"},
  {host: "ssvpichlgsies", name: "SSV Pichl Gsies"},
  {host: "sv-gossensass", name: "SV Gossensass"},
  {host: "sv-reischach", name: "SV Reischach"},
  {host: "svlanafussball", name: "SV Lana Fußball"},
  {host: "svv", name: "SVV"},
  {host: "topdive", name: "Topdive"},
  {host: "wipptalbroncos", name: "Wipptal Broncos"},
  {host: "wsvski", name: "WSV Ski"},
  {host: "asvwelschnofen", name: "ASV Welschnofen"},
  {host: "asv-latzfons", name: "ASV Latzfons"},
  {host: "asvhelm", name: "ASV Helm"},
  {host: "sg-eisacktal", name: "SG Eisacktal"},
  {host: "icehopper", name: "Icehopper"},
  {host: "basketclubbolzano", name: "Basket Club Bolzano"},
  {host: "abbate", name: "Abbate"}
]

  function filterWebsites(websites,filter){
   return websites.filter(website =>
    website.host.toLowerCase()
                .includes(filter.toLowerCase()))
  }

function App() {

const [filter, setFilter] = useState("");

  return (
    <div className="container">
      <header className="header">
        <h1>Registrix Vereinsübersicht</h1>
        <p>Finde deinen Verein und besuche die Registrix-Seite!</p>
      </header>
      <div className="filter-box">
        <label htmlFor="filter-input">Filter:</label>
        <input
          id="filter-input"
          className="filter-input"
          type="text"
          placeholder="Verein suchen..."
          value={filter}
          onChange={e => setFilter(e.target.value)}
        />
        <button className="clear-btn" onClick={() => setFilter("")}>Zurücksetzen</button>
      </div>
      <hr />
      <div className="list-box">
        <h2>Vereinsliste</h2>
        <ul className="website-list">
          {filterWebsites(registrixWebsites, filter).length === 0 ? (
            <li className="no-results">Kein Verein gefunden.</li>
          ) : (
            filterWebsites(registrixWebsites, filter)
              .sort((a, b) => a.name.localeCompare(b.name, 'de', { sensitivity: 'base' }))
              .map(website => (
                <li key={website.host} className="website-item">
                  <a
                    href={website.customUrl ? website.customUrl : `https://${website.host}.registrix.it`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="website-link"
                  >
                    {website.name}
                  </a>
                </li>
              ))
          )}
        </ul>
      </div>
    </div>
  );
}

export default App;  